import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../../theme";

const Container = styled(motion.div)`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 2rem 2rem 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
    padding: 3rem 1.5rem;
  }
`;

const ContentSection = styled(motion.div)`
  flex: 1;
  min-width: 300px;
`;

const ProductLabel = styled(motion.div)`
  color: ${theme.colors.primary};
  font-weight: 500;
  margin-bottom: 1rem;
  font-family: "Inter", sans-serif;
`;

const Title = styled(motion.h2)`
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  font-family: "Inter", sans-serif;
  color: ${theme.colors.text.primary};

  span {
    color: ${theme.colors.primary};
  }
`;

const Description = styled(motion.p)`
  color: ${theme.colors.text.tertiary};
  margin-bottom: 2rem;
  font-size: clamp(1rem, 2vw, 1rem);
  line-height: 1.6;
  font-family: "Inter", sans-serif;
`;

const FeatureList = styled(motion.ul)`
  list-style: none;
  padding: 0;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 768px) {
    text-align: left;
    padding: 0rem;
  }
`;

const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: ${theme.colors.text.primary};
  font-family: "Inter", sans-serif;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1.4;
  transition: transform 0.2s ease-in-out;

  svg {
    color: ${theme.colors.primary};
    flex-shrink: 0;
    border-radius: 50%;
    border: 2px solid ${theme.colors.primary};
    font-size: 1.2rem;
    margin-top: 0.15rem;
  }

  .text-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 0.2rem;

    .heading {
      font-weight: bold;
    }

    .description {
      font-weight: normal;
      color: ${theme.colors.text.tertiary};
      font-family: "Inter Regular", "Inter", sans-serif;
      letter-spacing: -0.4px;
      line-height: 1.4;
      font-size: 0.9rem;
    }
    .content {
      font-weight: normal;
      color: ${theme.colors.text.tertiary};
      font-family: "Inter Regular", "Inter", sans-serif;
      letter-spacing: -0.4px;
      line-height: 1.4;
      font-size: 0.8rem;
      text-align: left;
    }
  }

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
    gap: 0.5rem;

    .text-wrapper {
      flex-direction: column;

      .heading {
        font-size: 0.85rem;
      }

      .description {
        font-size: 0.75rem;
      }
    }

    svg {
      font-size: 1rem;
    }
  }
`;

const GetStartedButton = styled(motion.button)`
  background-color: ${theme.colors.primary};
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  transition: background-color 0.2s;
  min-width: 160px;
  font-size: clamp(1rem, 2vw, 1.1rem);

  &:hover {
    background-color: ${theme.colors.buttonhover};
    transform: scale(1.05);
    transition: transform 0.2s ease-in-out;
  }
`;

const ImageContainer = styled(motion.div)`
  flex: 1;
  min-width: 300px;
  position: relative;
  display: flex;
  justify-content: center;

  &::after {
    content: "";
    position: absolute;
    top: -2rem;
    right: 0rem;
    bottom: 2rem;
    left: 4rem;
    background: ${theme.colors.text.quaternary};
    border: 1px solid ${theme.colors.text.quinary};
    border-radius: 20px;
    z-index: -1;
  }

  @media (max-width: 1024px) {
    &::after {
      top: -1rem;
      right: -1rem;
      bottom: 2rem;
      left: 1rem;
    }
  }
`;

const Image = styled(motion.img)`
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 1rem;
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
`;

const SC = {
  Container,
  ContentSection,
  ProductLabel,
  Title,
  Description,
  FeatureList,
  FeatureItem,
  GetStartedButton,
  ImageContainer,
  Image,
};

export default SC;
